import { Button, DatePicker, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import EmptyContent from '../../../components/EmptyContent'
import { DATE_FORMAT_DEFAULT, ISO_DATE_FORMAT } from '../../../constants'
import { getStatusMapping } from '../InternalDocumentSignDocDetailPage/InternalDocumentSignDocHistory/InternalDocumentSignDocHistory'

const { RangePicker } = DatePicker
const { Option } = Select

const AdvanceFilterBlock = props => {
  const { electronicDocumentStore, onClose } = props
  const { queryParamsSignDocument } = electronicDocumentStore

  const location = useLocation()
  const history = useHistory()
  const queryStringParse = queryString.parse(location.search)
  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue({
      title: queryStringParse.title || undefined,
      status: queryStringParse.status || undefined,
      dateRange:
        queryStringParse.from_date && queryStringParse.to_date
          ? [moment(queryStringParse.from_date), moment(queryStringParse.to_date)]
          : undefined,
    })
  }, [queryStringParse, form])

  const onFinish = values => {
    const { title, status, dateRange } = values
    const from_date = dateRange ? moment(dateRange[0]).format(ISO_DATE_FORMAT) : null
    const to_date = dateRange ? moment(dateRange[1]).format(ISO_DATE_FORMAT) : null

    electronicDocumentStore.setQueryParamsSignDocument({
      ...queryParamsSignDocument,
      page: 0,
      title: title ? title.trim() : null,
      status: status || null,
      from_date,
      to_date,
    })

    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: 0,
        size: 10,
        title: title ? title.trim() : null,
        status: status || null,
        from_date,
        to_date,
      },
      { skipNull: true }
    )
    history.replace(`/internal-document/sign-document?${queryStringStringify}`)
    if (onClose) onClose()
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ width: '100%', maxHeight: '60vh', overflowY: 'auto', paddingRight: 8 }}
      className="advance-filter-form"
    >
      <style>{`
        .advance-filter-form .ant-form-item {
          margin-bottom: 16px;
        }
        .advance-filter-form .ant-form-item-label > label {
          color: #333;
        }
        .advance-filter-form .ant-input,
        .advance-filter-form .ant-input-affix-wrapper,
        .advance-filter-form .ant-picker,
        .advance-filter-form .ant-select-selector {
          border-radius: 8px !important;
        }
      `}</style>
      
      <Form.Item label="Tiêu đề" name="title">
        <Input placeholder="Nhập tiêu đề" allowClear />
      </Form.Item>

      <Form.Item label="Trạng thái" name="status">
        <Select
          allowClear
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          notFoundContent={<EmptyContent />}
          optionFilterProp={'name'}
          placeholder={'Chọn trạng thái'}
        >
          {Object.keys(getStatusMapping).map(statusKey => (
            <Option key={statusKey} value={statusKey} name={statusKey}>
              {getStatusMapping[statusKey]}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Ngày trình" name="dateRange">
        <RangePicker
          style={{ width: '100%' }}
          placeholder={['Từ ngày', 'Đến ngày']}
          format={DATE_FORMAT_DEFAULT}
        />
      </Form.Item>

      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginTop: 24, marginBottom: 8 }}>
        <Button onClick={onClose} style={{ borderRadius: 8, flex: 1, height: 40 }}>
          Huỷ
        </Button>
        <Button type="primary" htmlType="submit" style={{ borderRadius: 8, flex: 1, height: 40 }}>
          Áp dụng
        </Button>
      </div>
    </Form>
  )
}

AdvanceFilterBlock.propTypes = {}

export default inject('electronicDocumentStore')(observer(AdvanceFilterBlock))
